
import {MAX_TEST_AGENTS} from './test-agents-defs'

export default {
  props: {
    agents: {type: Array, required: true},
    editing_idx: {type: Number, default: undefined},
    saving: Boolean,
    saved_at: {type: Number, default: undefined}
  },
  emits: ['edit', 'delete'],
  data() {
    return {
      max_agents: MAX_TEST_AGENTS
    }
  }
}
